const ROLES = {
  CAT: {
    name: 'CAT',
    description: "Membre du CAT",
    redirectPath: "/orders/box/1"
  },
  Referent: {
    name: 'Referent',
    description: "Référent tumeplay",
    redirectPath: "/orders/referent"
  },
  Authenticated: {
    name: 'authenticated',
    redirectPath: '/settings'
  }
}

export default ROLES;
